import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/about')({
  component: AboutPage,
})

function AboutPage() {
  return (
    <section>
      <h1>About</h1>
      <p>This app uses TanStack Router for client-side routing.</p>
    </section>
  )
}
